export const categories = [
  { slug: "all", name: "全部", icon: "ri-apps-2-line" },
  { slug: "romance", name: "恋爱", icon: "ri-heart-line" },
  { slug: "fantasy", name: "奇幻", icon: "ri-magic-line" },
  { slug: "action", name: "动作", icon: "ri-flashlight-line" },
  { slug: "thriller", name: "悬疑", icon: "ri-search-eye-line" },
  { slug: "comedy", name: "搞笑", icon: "ri-emotion-laugh-line" },
  { slug: "drama", name: "剧情", icon: "ri-film-line" },
  { slug: "horror", name: "恐怖", icon: "ri-ghost-line" },
  { slug: "school", name: "校园", icon: "ri-building-line" },
  { slug: "historical", name: "古风", icon: "ri-ancient-gate-line" },
  { slug: "sports", name: "运动", icon: "ri-basketball-line" },
  { slug: "scifi", name: "科幻", icon: "ri-rocket-line" },
];

export const comics = [
  {
    id: 1,
    title: "我独自升级",
    slug: "solo-leveling",
    author: "Chugong / Jang Sung-rak",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20solo%20leveling%20style%20dark%20fantasy%20hunter%20with%20blue%20flame%20shadow%20army%2C%20epic%20warrior%20silhouette%20against%20dark%20background%2C%20dramatic%20lighting%2C%20action%20poster%20art&width=600&height=800&seq=comic-solo-leveling&orientation=portrait",
    rating: 9.8,
    category: "fantasy",
    tags: ["奇幻", "动作", "升级流"],
    description: `十年前，被称为"门"的异次元通道突然出现，与之同时，部分人类觉醒了超能力成为"猎人"。在这个世界里，最弱的E级猎人成振宇，在一次几乎丧命的双重地下城事件后，获得了一个神秘的任务系统。从此，他成为了唯一能够"升级"的猎人，开始了从最弱到最强的逆袭之路。这部作品以其宏大的世界观、精彩的战斗场面和扣人心弦的剧情，成为了韩国漫画史上的里程碑之作。`,
    updateDate: "2026-08-01",
    views: 15200000,
    chapters: 200,
    status: "已完结",
    ranking: 1,
  },
  {
    id: 2,
    title: "女神降临",
    slug: "true-beauty",
    author: "Yaongyi",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20style%20beautiful%20makeup%20transformation%20girl%20with%20long%20hair%2C%20soft%20pastel%20tones%2C%20school%20romance%20drama%2C%20cute%20heart%20illustration%20style%2C%20clean%20pink%20white%20background&width=600&height=800&seq=comic-true-beauty&orientation=portrait",
    rating: 9.5,
    category: "romance",
    tags: ["恋爱", "校园", "美妆"],
    description: `因为外貌而自卑的女高中生任朱静，通过化妆技巧实现了惊人的"女神变身"。转学到新学校后，她成为了众人眼中的完美女神。然而，素颜的秘密随时可能被揭穿。在校园里，她遇到了两位截然不同的男生——高冷学霸李修豪和阳光校草韩书俊，展开了一段青春洋溢又充满笑料的恋爱故事。这部作品不仅讲述了爱情，更传递了"真正的美丽来自内心"的温暖主题。`,
    updateDate: "2026-07-28",
    views: 13800000,
    chapters: 237,
    status: "已完结",
    ranking: 2,
  },
  {
    id: 3,
    title: "全知读者视角",
    slug: "omniscient-reader",
    author: "sing N song / Sleepy-C",
    cover: "https://readdy.ai/api/search-image?query=Korean%20apocalyptic%20fantasy%20manhwa%20style%20man%20reading%20book%20with%20constellation%20stars%20in%20sky%2C%20post%20apocalyptic%20city%20ruins%2C%20dramatic%20cosmic%20purple%20dark%20background%2C%20epic%20illustration&width=600&height=800&seq=comic-omniscient-reader&orientation=portrait",
    rating: 9.7,
    category: "fantasy",
    tags: ["奇幻", "末世", "系统"],
    description: `平凡上班族金独子是连载小说《在灭亡的世界中生存的三种方法》长达十年的唯一读者。当小说的最终话发布后，他收到了作者发来的神秘文件。紧接着，小说中描述的世界末日场景竟然在现实中上演了。凭借对小说剧情的全面了解，金独子成为了这个世界上唯一知道"结局"的人。他必须利用自己的知识，在这个残酷的世界中生存下去，并改写所有人的命运。`,
    updateDate: "2026-08-03",
    views: 12100000,
    chapters: 189,
    status: "连载中",
    ranking: 3,
  },
  {
    id: 4,
    title: "她与野兽",
    slug: "she-and-the-beast",
    author: "The miso / Haeyun",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20fantasy%20manhwa%20style%20beautiful%20woman%20with%20mysterious%20man%20in%20palace%20garden%2C%20rose%20flowers%2C%20elegant%20historical%20dress%2C%20soft%20romantic%20lighting%2C%20vintage%20painting%20style&width=600&height=800&seq=comic-she-and-beast&orientation=portrait",
    rating: 9.3,
    category: "romance",
    tags: ["恋爱", "奇幻", "古风"],
    description: `在帝国最阴暗的森林深处，传闻住着一个被诅咒的野兽。贵族小姐艾琳为了拯救家族，不得不前往那座禁忌的城堡。然而她发现，所谓的"野兽"竟是一位被魔法诅咒的俊美公爵。只要有人真心爱他，诅咒便会解除。艾琳在城堡中住下，日复一日，两颗孤独的心逐渐靠近。但当诅咒的真相浮出水面时，她发现自己早已深陷其中无法自拔。`,
    updateDate: "2026-07-25",
    views: 8900000,
    chapters: 156,
    status: "连载中",
    ranking: 4,
  },
  {
    id: 5,
    title: "甜蜜的家庭",
    slug: "sweet-home",
    author: "Kim Carnby / Hwang Young-chan",
    cover: "https://readdy.ai/api/search-image?query=Korean%20horror%20thriller%20manhwa%20style%20apartment%20building%20surrounded%20by%20monsters%2C%20young%20man%20with%20weapon%20guarding%20door%2C%20dark%20tense%20atmosphere%2C%20survival%20horror%20poster%20art&width=600&height=800&seq=comic-sweet-home&orientation=portrait",
    rating: 9.4,
    category: "horror",
    tags: ["恐怖", "末世", "生存"],
    description: `因校园霸凌和家庭悲剧而失去生活希望的高中生车贤秀，搬到了一栋名为"绿之家"的老旧公寓，打算结束自己的生命。然而，突如其来的末日降临了——人们开始变成可怕的怪物，而触发变异的关键竟是内心的"欲望"。被困在公寓中的幸存者们必须团结起来对抗怪物，同时还要抵抗自己内心不断涌现的欲望，避免变成怪物的一员。在这绝望的环境中，贤秀重新找到了活下去的理由。`,
    updateDate: "2026-06-20",
    views: 10200000,
    chapters: 141,
    status: "已完结",
    ranking: 5,
  },
  {
    id: 6,
    title: "重生之都市修仙",
    slug: "rebirth-urban-cultivation",
    author: "Lee Jong-hui / Kim Dong-jun",
    cover: "https://readdy.ai/api/search-image?query=Korean%20action%20fantasy%20manhwa%20style%20martial%20artist%20cultivator%20with%20glowing%20energy%20in%20modern%20city%2C%20dynamic%20action%20pose%2C%20neon%20city%20lights%2C%20powerful%20aura%20illustration&width=600&height=800&seq=comic-rebirth-cultivation&orientation=portrait",
    rating: 9.2,
    category: "action",
    tags: ["动作", "修仙", "都市"],
    description: `修仙界第一强者陈凡，在渡劫飞升时遭到背叛陨落。醒来时，他发现自己回到了少年时代——地球上的一个普通高中生。带着千年的修仙记忆和战斗经验，陈凡在这个灵气稀薄的现代都市中重新踏上修仙之路。他曾在仙界笑傲群雄，如今在地球上同样将掀起惊涛骇浪。昔日欺辱过他的人，终将为当初的选择付出代价。`,
    updateDate: "2026-08-02",
    views: 7600000,
    chapters: 312,
    status: "连载中",
    ranking: 6,
  },
  {
    id: 7,
    title: "观相师",
    slug: "the-physiognomist",
    author: "Yoon Tae-ho / Kim Seon-min",
    cover: "https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20style%20mysterious%20detective%20reading%20faces%20with%20magnifying%20glass%2C%20crime%20scene%20investigation%2C%20noir%20atmosphere%2C%20dark%20alleyways%2C%20suspense%20thriller%20poster&width=600&height=800&seq=comic-physiognomist&orientation=portrait",
    rating: 9.1,
    category: "thriller",
    tags: ["悬疑", "犯罪", "推理"],
    description: `拥有"看脸读心"特殊能力的观相师金道振，能够通过人的面部特征洞察其内心和命运。他利用这项能力在暗处帮助警方破获了无数悬案。然而，一宗连环杀人案的出现打破了他的平静生活——凶手似乎也具备某种超自然能力，每一次犯案都在向道振发出挑衅。两个拥有特殊能力的人，展开了一场跨越生死的智力对决。`,
    updateDate: "2026-07-30",
    views: 5400000,
    chapters: 98,
    status: "连载中",
    ranking: 7,
  },
  {
    id: 8,
    title: "社内相亲",
    slug: "business-proposal",
    author: "Haehwa / Narak",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romantic%20comedy%20manhwa%20style%20young%20woman%20in%20office%20disguise%20meeting%20handsome%20CEO%2C%20blind%20date%20scenario%2C%20bright%20cheerful%20office%20background%2C%20fashionable%20city%20style&width=600&height=800&seq=comic-business-proposal&orientation=portrait",
    rating: 9.0,
    category: "comedy",
    tags: ["搞笑", "恋爱", "职场"],
    description: `食品公司研究员申夏莉代替闺蜜去参加一场相亲，本想故意搞砸让对方知难而退。然而，相亲对象竟然是自己的公司社长姜泰武！更糟糕的是，社长不但没有被吓跑，反而对她产生了浓厚的兴趣。为了隐瞒真实身份，夏莉不得不在社长的追求和闺蜜的期待之间左右为难。一场啼笑皆非的办公室爱情喜剧就此展开。`,
    updateDate: "2026-06-15",
    views: 6700000,
    chapters: 125,
    status: "已完结",
    ranking: 8,
  },
  {
    id: 9,
    title: "恶役只有死亡结局",
    slug: "villains-are-destined-to-die",
    author: "Gwon Gyeoeul / Suol",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20fantasy%20manhwa%20style%20noble%20lady%20in%20palace%20interior%20holding%20roses%2C%20elegant%20gown%2C%20golden%20light%2C%20tragic%20beauty%2C%20classic%20painting%20style&width=600&height=800&seq=comic-villain-destiny&orientation=portrait",
    rating: 9.6,
    category: "drama",
    tags: ["剧情", "穿越", "贵族"],
    description: `普通大学生穿越到了自己正在玩的恋爱模拟游戏中，却成为了游戏里注定死亡的反派角色——公爵之女佩内洛普。在游戏中，无论选择哪条路线，佩内洛普都会在结局时悲惨死去。为了改变命运，她决定不再遵循游戏的设定。然而，五个攻略角色的好感度系统依然在运作，每一个选择都可能引向不同的结局。当"好感度为零即死亡"的残酷规则浮现后，她必须小心翼翼地经营每一段关系，才能在这场生死游戏中存活下来。`,
    updateDate: "2026-08-01",
    views: 9500000,
    chapters: 145,
    status: "连载中",
    ranking: 9,
  },
  {
    id: 10,
    title: "神之塔",
    slug: "tower-of-god",
    author: "SIU",
    cover: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20adventure%20manhwa%20style%20giant%20mysterious%20tower%20reaching%20sky%2C%20young%20boy%20climbing%20with%20determination%2C%20magical%20floating%20platforms%2C%20epic%20scale%2C%20starry%20sky%20background&width=600&height=800&seq=comic-tower-of-god&orientation=portrait",
    rating: 9.3,
    category: "fantasy",
    tags: ["奇幻", "冒险", "友情"],
    description: `在一个被神秘巨塔所支配的世界里，传说登上塔顶之人可以实现任何愿望。少女蕾哈尔为了追寻塔顶的星空，决定进入神之塔。少年二十五夜为了追寻蕾哈尔的脚步，也紧随其后闯入塔中。然而这座塔并非寻常之地——每一层都是一个独立的世界，充满了致命的考验和强大的敌人。二十五夜凭借纯真的心灵和与生俱来的特殊能力，在塔中不断成长，结识伙伴，揭开塔的秘密。`,
    updateDate: "2026-07-20",
    views: 8300000,
    chapters: 550,
    status: "连载中",
    ranking: 10,
  },
  {
    id: 11,
    title: "某天成为公主",
    slug: "who-made-me-a-princess",
    author: "Plutus / Spoon",
    cover: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20manhwa%20style%20cute%20young%20princess%20with%20blonde%20hair%20in%20royal%20palace%20garden%2C%20sparkling%20magic%20dust%2C%20fairy%20tale%20atmosphere%2C%20pastel%20golden%20warm%20light&width=600&height=800&seq=comic-made-me-princess&orientation=portrait",
    rating: 9.4,
    category: "school",
    tags: ["校园", "奇幻", "亲情"],
    description: `一觉醒来，我变成了小说《可爱的公主》中的悲剧配角——将被自己亲生父亲处死的公主阿塔纳西娅。为了避免悲惨的命运，她从小就努力讨好那位冷酷无情的皇帝父亲克劳德。从牙牙学语到蹒跚学步，她用天真烂漫的笑容一点一点融化了皇帝冰冷的心。然而，当小说中真正的女主角登场时，阿塔纳西娅的命运又将走向何方？`,
    updateDate: "2026-05-30",
    views: 7100000,
    chapters: 125,
    status: "已完结",
    ranking: 11,
  },
  {
    id: 12,
    title: "极限足球",
    slug: "extreme-soccer",
    author: "Park Jin-hwan / Lee Sang-min",
    cover: "https://readdy.ai/api/search-image?query=Korean%20sports%20manhwa%20style%20soccer%20player%20dribbling%20ball%20with%20intense%20focus%2C%20stadium%20floodlights%2C%20dynamic%20motion%2C%20green%20field%2C%20sports%20drama%20poster%20art&width=600&height=800&seq=comic-extreme-soccer&orientation=portrait",
    rating: 8.9,
    category: "sports",
    tags: ["运动", "热血", "竞技"],
    description: `少年尹尚赫在一个足球并不流行的乡下小镇长大，却拥有惊人的足球天赋。在一次偶然的机会下，他被首尔名校的球探发现，获得了进入全国最强高中足球队的机会。然而城市里的足球世界远比他想象的残酷——天赋异禀的队友、严格的训练、激烈的竞争，以及来自对手的无情挑战。尚赫用对足球的纯粹热爱和不懈努力，一步步征服所有人的心，向着职业球员的梦想冲刺。`,
    updateDate: "2026-07-15",
    views: 3800000,
    chapters: 210,
    status: "连载中",
    ranking: 12,
  },
  {
    id: 13,
    title: "星际快递员",
    slug: "space-courier",
    author: "Jung Seo-yoon / Park Hyun-woo",
    cover: "https://readdy.ai/api/search-image?query=Korean%20sci-fi%20manhwa%20style%20space%20delivery%20pilot%20in%20futuristic%20spaceship%2C%20colorful%20nebula%20galaxy%20background%2C%20cyberpunk%20elements%2C%20planet%20rings%2C%20adventure%20sci-fi%20illustration&width=600&height=800&seq=comic-space-courier&orientation=portrait",
    rating: 8.8,
    category: "scifi",
    tags: ["科幻", "冒险", "宇宙"],
    description: `公元2357年，人类已经遍布银河系各个角落。星际快递员成为了连接各个星球最重要的职业。新入职的快递员李银河在一次普通派送任务中，意外收到了一件神秘的包裹——里面竟然藏着一个被全宇宙通缉的人工智能生命体。为了保护这个拥有自我意识的存在，银河踏上了横跨星际的逃亡之旅。浩瀚宇宙中，一个关于生命、自由与选择的故事由此展开。`,
    updateDate: "2026-07-10",
    views: 2900000,
    chapters: 87,
    status: "连载中",
    ranking: 13,
  },
  {
    id: 14,
    title: "武林高手在校园",
    slug: "martial-master-in-school",
    author: "Kwon Sung-min / Choi Jin-woo",
    cover: "https://readdy.ai/api/search-image?query=Korean%20action%20comedy%20manhwa%20style%20martial%20arts%20master%20teenager%20in%20school%20uniform%20with%20fighting%20stance%2C%20school%20hallway%2C%20dynamic%20energy%2C%20humorous%20tone%2C%20bright%20anime%20illustration&width=600&height=800&seq=comic-martial-school&orientation=portrait",
    rating: 8.7,
    category: "comedy",
    tags: ["搞笑", "动作", "校园"],
    description: `曾经的武林至尊张天豪，在与宿敌决战后坠落悬崖。醒来时发现自己竟然附身在一个现代高中生的身上。昔日的绝世高手变成了一个手无缚鸡之力的普通学生，还要面对考试、作业和校园霸凌这些"从未见过的武功招式"。但堂堂武林至尊岂会被人踩在脚下？张天豪决定用自己高强的武功，在新世界里重新称霸——只不过这次的战场从武林变成了学校。`,
    updateDate: "2026-07-05",
    views: 4500000,
    chapters: 167,
    status: "连载中",
    ranking: 14,
  },
  {
    id: 15,
    title: "朝鲜王朝秘史",
    slug: "joseon-secret-history",
    author: "Park Min-ji / Lee Soo-jin",
    cover: "https://readdy.ai/api/search-image?query=Korean%20historical%20manhwa%20style%20Joseon%20dynasty%20royal%20court%20lady%20in%20traditional%20hanbok%2C%20ancient%20palace%20corridor%2C%20moonlight%2C%20historical%20drama%2C%20elegant%20traditional%20ink%20painting%20style&width=600&height=800&seq=comic-joseon-history&orientation=portrait",
    rating: 9.0,
    category: "historical",
    tags: ["古风", "宫斗", "历史"],
    description: `朝鲜王朝中期，年轻的史官之女韩素英女扮男装潜入宫中，想要调查父亲离奇死亡的真相。在宫廷的重重迷雾中，她遇到了表面玩世不恭实则深藏不露的二王子李珒。两人在权力斗争和宫廷阴谋中互相扶持，逐渐产生了超越身份的情感。然而，当真相大白的那一刻，素英发现自己所爱之人，竟与父亲的死有着千丝万缕的联系。`,
    updateDate: "2026-06-28",
    views: 5100000,
    chapters: 134,
    status: "已完结",
    ranking: 15,
  },
  {
    id: 16,
    title: "恐怖便利商店",
    slug: "horror-convenience-store",
    author: "Jung Min-woo / Kim Tae-hoon",
    cover: "https://readdy.ai/api/search-image?query=Korean%20horror%20thriller%20manhwa%20style%20creepy%20convenience%20store%20at%20night%2C%20eerie%20fluorescent%20lights%2C%20shadowy%20figure%20standing%20behind%20counter%2C%20suspense%2C%20dark%20urban%20legend%20vibe&width=600&height=800&seq=comic-horror-store&orientation=portrait",
    rating: 8.6,
    category: "horror",
    tags: ["恐怖", "都市传说", "惊悚"],
    description: `深夜兼职的大学生金秀敏，在一家24小时便利商店工作。看似平常的夜班里，怪事接连不断地发生——半夜独自来买特定商品的诡异顾客、监控录像中出现的无法解释的影像、以及每到凌晨三点准时响起的求助电话。随着调查的深入，秀敏发现这家便利店建在一座被封印的古墓之上，而每天晚上光顾的"顾客"们，并不全是活人。`,
    updateDate: "2026-06-12",
    views: 3400000,
    chapters: 78,
    status: "连载中",
    ranking: 16,
  },
];

export const faqs = [
  {
    question: "韩国漫画和日本漫画有什么区别？",
    answer: `韩国漫画（Webtoon）与日本漫画的主要区别在于：1）阅读方式——韩国漫画多为纵向滚动条式阅读，适合手机浏览；日本漫画多为传统翻页式。2）色彩——韩国漫画多为全彩制作，画面更加鲜艳丰富；日本漫画多为黑白。3）更新频率——韩国漫画通常每周更新一话，节奏更快。4）题材——韩国漫画在恋爱、职场、奇幻题材上表现出色，叙事风格更贴近现代生活。`,
  },
  {
    question: "韩国漫画一般多久更新一次？",
    answer: `大多数热门韩国漫画采用周更模式，通常每周固定一天更新一话。部分高人气作品偶尔会加更。连载平台如KakaoPage、Naver Webtoon一般在北京时间晚上更新。需要注意的是，作者的健康状况和节假日可能会影响更新节奏，平台通常会提前通知停更消息。`,
  },
  {
    question: "在哪里可以看正版韩国漫画？",
    answer: `正版韩国漫画可以通过以下渠道观看：国内平台方面，PODO漫画、咚漫、快看漫画等引进了大量正版韩国漫画资源。海外平台方面，Naver Webtoon的官方中文版（LINE Webtoon）提供了丰富的官方翻译作品，KakaoPage也在逐步拓展中文市场。建议优先选择正版平台，支持创作者，同时获得更好的阅读体验和翻译质量。`,
  },
  {
    question: "韩国漫画的推荐标准是什么？",
    answer: `我们的推荐标准综合考虑了以下维度：1）剧情质量——故事是否引人入胜、逻辑是否自洽；2）画风表现——画面质量、人物设计、色彩运用；3）人气数据——阅读量、评论数、分享率等客观指标；4）读者口碑——综合各大平台的真实用户评价；5）专业评审——结合业内人士和资深读者的专业意见。我们致力于提供客观公正的推荐，帮助大家找到适合自己的优秀作品。`,
  },
  {
    question: "如何快速找到适合自己的韩国漫画？",
    answer: `建议从以下几个角度入手：1）先确定自己喜欢的题材类型（恋爱、奇幻、悬疑等），然后在我们网站的对应分类中浏览；2）参考排行榜和热门推荐，这些作品经过了大量读者的检验；3）阅读详细推荐文章，了解作品的剧情、画风和特点；4）可以关注"已完结"标签的作品，一次性看完不用担心追更。如果不确定自己喜欢什么类型，可以先从评分9.0以上的作品开始尝试。`,
  },
  {
    question: "韩国漫画适合什么年龄段的读者？",
    answer: `韩国漫画覆盖了非常广泛的年龄段和受众群体。校园恋爱类作品主要面向青少年读者（13岁以上），职场剧情类作品更适合成年人阅读，而部分含有暴力、恐怖元素的作品则有明确的年龄限制（通常18岁以上）。每部作品在平台上都会有相应的年龄分级标识，建议读者根据自己的年龄和承受能力选择合适的作品。我们在推荐时也会特别注明适合的阅读人群。`,
  },
];

export const siteInfo = {
  name: "韩国漫画推荐",
  slogan: "发现你的下一部韩国漫画",
  description: "精选好看的韩国漫画推荐与排行榜，涵盖免费韩国漫画大全、高分必看作品，在线看人气韩国漫画，发现你的下一部韩国漫画。",
  email: "contact@koreancomics.cn",
  foundedYear: "2020",
  totalRecommendations: "500+",
  monthlyVisitors: "200万+",
  expertReviewers: "30+",
};